import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import "./Section_7.css";

const Section_7 = () => {
  const [testimonials, setTestimonials] = useState([]);

  // Fetch testimonials from backend
  useEffect(() => {
    axios
      .get("https://urbancasabackendfiles.onrender.com/api/testimonials") // Change URL when deploying
      .then((response) => {
        setTestimonials(response.data);
      })
      .catch((error) => {
        console.error("Error fetching testimonials:", error);
      });
  }, []);

  return (
    <section className="testimonial-section">
      <h2 className="testimonial-heading">
        Hear What Our <span>Happy Clients</span> Have to Say
      </h2>
      <Swiper
  spaceBetween={20}
  pagination={{ clickable: true }}
  modules={[Pagination]}
  className="testimonial-slider"
  breakpoints={{
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 1.5,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 2.5,
    },
    1280: {
      slidesPerView: 3,
    },
  }}
>
  {testimonials.map((testimonial, index) => (
    <SwiperSlide key={testimonial._id || index} className="testimonial-card">
      <h3>{testimonial.name}</h3>
      <p className="role">{testimonial.role}</p>
      <p className="text">"{testimonial.text}"</p>
    </SwiperSlide>
  ))}
</Swiper>

    </section>
  );
};

export default Section_7;
